export default __webpack_public_path__ + "static/niw-b4e22c153c5257780862c94b23bf961c.png";